import React, {Component} from 'react';

import style from '../css/counter.css';

class Counter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            countValue: '',
        }
    }

    render() {
        let counterWrapperStyle = this.props.wrapperStyle
            ? this.props.wrapperStyle
            : null;

        clearTimeout(this.handle);
        this.handle = setTimeout(() => this.setState({
            ...this.state,
            countValue: this.props.count < 100
                ? this.props.count
                : '+99',
        }), this.props.animate ? 1000 : 0);

        let counterStyle = (this.state.countValue === '') ? `${style.counterContainer} ${style.counterContainerVisibility}` : style.counterContainer;

        return (<div id='bet_slip_accordion'  className={counterWrapperStyle}>
            <div className={counterStyle}>
                <div className={style.counter}>{this.state.countValue}</div>
            </div>
        </div>);
    }
}

export default Counter;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/counter.js